module.exports = __webpack_public_path__ + "static/pipeline-update-category_4-60c0991760bd39fa082b5561de7d5f48.png";